import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button
} from "reactstrap";
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import FileUpload from "components/Common/file-upload/file-upload.component";
import MyMap from "components/Common/google-map/MyMap";
import Language from "Enums/Language"
import SelectOptions from "components/SelectOptions"
import { toast } from "react-toastify";
import { salesDeveloperPrefix } from "configs/routePrefix";
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import CancelModal from "../CancelModal"
import moment from "moment"
import SuccessModal from "components/SucessModal"
import { useSelector } from "react-redux";
import CompoundService from "services/SalesDeveloper/CompoundService";
import AreasService from "services/SalesDeveloper/AreasService";
import FacilitiesService from "services/SalesDeveloper/FacilitiesService";

const languages = ["en", "ar", "zh", "ru"]


const CompoundForm = (props) => {
    const filterData = useSelector(state=> state.adminFilter)
    const [successModal, setSuccessModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [goOut, setGoOut] = useState(false)
    const [modal, setModal] = useState(false)
    const compoundService = new CompoundService()
    const [uploadState, setUploadState] = useState(false)
    const [formData, setFormData] = useState({
        ar: "",
        en: "",
        ru: "",
        zh: "",
        descrip_ar: "",
        descrip_en: "",
        descrip_ru: "",
        descrip_zh: "",
        address_ar: "",
        address_en: "",
        address_ru: "",
        address_zh: "",
        selectedArea: null,
        selectedDeveloper: null,
        selectedFacilities: [],
        lat: 30.005493,
        lng: 31.477898,
    })
    const [mediaIds, setMediaIds] = useState([])
    const [videosIds, setVideosIds] = useState([])
    const [developerOptions, setDeveloperOptions] = useState([])
    const [AreaOptions, setAreaOptions] = useState([])
    const [facilitiesOptions, setFacilitiesOptions] = useState([])
    const [mapRender, setMapRender] = useState(0)

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }, [])

    useEffect(() => {
        if (props.id && props.fromParams) {
            compoundService.find(props.id).then(response => {
                if (response && response.status === SuccessOk) {
                    setFormData({
                        ar: response.data.name.ar,
                        en: response.data.name.en,
                        ru: response.data.name.ru,
                        zh: response.data.name.zh,
                        descrip_ar: response.data.description.ar,
                        descrip_en: response.data.description.en,
                        descrip_ru: response.data.description.ru,
                        descrip_zh: response.data.description.zh,
                        address_ar: response.data.address.ar,
                        address_en: response.data.address.en,
                        address_ru: response.data.address.ru,
                        address_zh: response.data.address.zh,
                        selectedArea: {
                            label: response.data.area.name.en,
                            value: response.data.area.id
                        },
                        selectedDeveloper: {
                            label: response.data.developer.name.en,
                            value: response.data.developer.id,
                        },
                        // delivery_date: delivary,
                        lat: Number(response.data.lat),
                        lng: Number(response.data.lang),
                    })


                    const newSelected = response.data.facilities.map(item => {
                        return {
                            label: item ?.name ?.en,
                            value: item.id
                        }
                    })
                    setFormData((formData) => ({ ...formData, selectedFacilities: [...newSelected] }))
                    setVideosIds(response.data.videos)
                    setMediaIds(response.data.images)
                    setMapRender(mapRender + 1)
                }
            })
        } else {
            if (props.id) {
                setFormData({
                    ar: props.compoundData.name.ar ? props.compoundData.name.ar  : "",
                    en: props.compoundData.name.en? props.compoundData.name.en : "",
                    ru: props.compoundData.name.ru? props.compoundData.name.ru : "",
                    zh: props.compoundData.name.zh? props.compoundData.name.zh  : "",
                    descrip_ar: props.compoundData.description.ar? props.compoundData.description.ar : "",
                    descrip_en: props.compoundData.description.en? props.compoundData.description.en : "",
                    descrip_ru: props.compoundData.description.ru? props.compoundData.description.ru : "",
                    descrip_zh: props.compoundData.description.zh? props.compoundData.description.zh  : "",
                    address_ar: props.compoundData.address.ar? props.compoundData.address.ar : "",
                    address_en: props.compoundData.address.en? props.compoundData.address.en : "",
                    address_ru: props.compoundData.address.ru? props.compoundData.address.ru : "",
                    address_zh: props.compoundData.address.zh? props.compoundData.address.zh : "",
                    // delivery_date: props.compoundData.delivery_date,
                    selectedDeveloper: props.compoundData.developer_id,
                    selectedArea: props.compoundData.area_id,
                    selectedFacilities: [...props.compoundData.facilities_ids],
                    lat: props.compoundData.lat,
                    lng: props.compoundData.lang, 
                })
                setVideosIds(props.compoundData.videos_ids)
                setMediaIds(props.compoundData.images_ids)
                setMapRender(mapRender + 1)
            } else {
                setMapRender(mapRender + 1)
            }
        }
    }, [])

    const updateLocationPositions = (lat, lng) => {
        setFormData({ ...formData, ...{ lat, lng } });
    };
    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const updatedAttachment = (attachments, type) => {
        if (type === "media_id") {
            setMediaIds([...mediaIds, ...attachments])
        } else {
            setVideosIds([...videosIds, ...attachments])
        }
    };

    const deleteAttachment = (Items, type) => {
        if (type === "media_id") {
            let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
            setMediaIds(updatedMedia)
        } else {
            let updatedMedia = videosIds.filter(item => item.id != Items[0].id)
            setVideosIds(updatedMedia)
        }
    };

    const checkVlidation = () => {
        if (formData ?.selectedFacilities ?.length === 0) {
            return false
        } else {
            return true
        }
    }

    const checkVlidationDeveloper = () => {
        if (formData.selectedDeveloper === null && !filterData.developer_id) {
            return true
        } else {
            return false
        }
    }
    const checkVlidationArea = () => {
        if (formData.selectedArea === null ) {
            return false
        } else {
            return true
        }
    }
    const handeSubmit = (values) => {
        if (!checkVlidation()) {
            toast.error("Please choose Facility")
            return
        }
        else if (!checkVlidationArea()) {
            toast.error("Please choose Area")
            return
        }
        setLoading(true)

        const data = {
            name: { en: formData.en },
            description: {},
            address: { en: formData.address_en },
            developer_id: filterData?.developer_id,
            area_id: formData.selectedArea.value,
            lat: formData.lat,
            lang: formData.lng,
            facilities_ids: [...formData.selectedFacilities ?.map(item => item ?.value)],
            images_ids: mediaIds.map(item => item.id),
            videos_ids: videosIds.map(item => item.id)
        }
        languages.forEach(language => {
            if (formData[language].length) {
                data.name[language] = formData[language]
            }
        })
        languages.forEach(language => {
            if (formData[`descrip_${language}`].length) {
                data.description[language] = formData[`descrip_${language}`]
            }
        })
        languages.forEach(language => {
            if (formData[`address_${language}`].length) {
                data.address[language] = formData[`address_${language}`]
            }
        })

        if (props ?.id) {
            compoundService.update(props ?.id, data).then(response => {
                if (response && response.status === SuccessCreated) {
                    // toast.success("compound has been updated")
                    if (goOut) {
                        setSuccessModal(true)

                    } else {
                        props.setCompoundData({
                            ...data,
                            developer_id: formData.selectedDeveloper,
                            area_id: formData.selectedArea,
                            facilities_ids: [...formData.selectedFacilities],
                            images_ids: mediaIds,
                            videos_ids: videosIds,
                            // delivery_date:formData.delivery_date
                        })
                        props.nextFormStep()
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                    }
                } else {
                    setLoading(false)
                }
            })
        }
        else {
            compoundService.create(data).then(response => {
                if(typeof response === 'string'){
                    toast.error(response)
                    setLoading(false)
                    return
                }
                if (response && response.status === SuccessCreated) {
                    toast.success("New compound has been added")
                    if (goOut) {
                        props ?.history ?.push(`${salesDeveloperPrefix}/compound/compound-list`);
                    } else {
                        props.setCompoundData({
                            ...data,
                            developer_id: formData.selectedDeveloper,
                            area_id: formData.selectedArea,
                            facilities_ids: [...formData.selectedFacilities],
                            images_ids: mediaIds,
                            videos_ids: videosIds,
                            // delivery_date:formData.delivery_date

                        })
                        props.setCompoundId(response.data[0])
                        props.nextFormStep()
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        })
                    }
                } else {
                    setLoading(false)
                }
            })
        }
    }
    return (
        <React.Fragment>
            <AvForm className="form-horizontal" onValidSubmit={(e, v) => {
                handeSubmit(v)
            }}
            >
                <Card className="w-100 mt-4">
                    <CardBody>
                        {/* <Row className="mb-1">
                            <h2>Name</h2>
                        </Row> */}
                        <Row>
                            {Language.LIST.map((lan, index) => {
                                return (
                                    <Col md={6} key={index} >
                                        <AvField
                                            className="mb-3"
                                            name={lan.name}
                                            label={`Compound Name (${lan.name})`}
                                            bsSize="lg"
                                            value={formData[`${lan.name}`]}
                                            onChange={(e => handleFieldChange(e))}
                                            required={lan.name === "en" ? true : false}
                                            errorMessage="This field is required"
                                            placeholder={lan.name === "en" ? 'English' : lan.name === "ar" ? "العربية" : lan.name === "zh" ? "中文" : "Русский"}
                                        />
                                    </Col>
                                )
                            })}
                        </Row>
                        <Row>
                            <Col md={6}>
                                <SelectOptions
                                    label='Facilities'
                                    placeholder='Select'
                                    options={facilitiesOptions}
                                    handleSelectChange={(data) => {
                                        setFormData({ ...formData, selectedFacilities: data });
                                    }}
                                    selectedOption={formData.selectedFacilities}
                                    Service={FacilitiesService}
                                    setOptions={(options) => {
                                        setFacilitiesOptions(options)
                                    }}
                                    isMulti={true}
                                />
                            </Col>
                        </Row>
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={12} key={index} >
                                    <AvField
                                        className="mb-3"
                                        name={lan.descrip_name}
                                        label={`Description (${lan.name})`}
                                        bsSize="lg"
                                        value={formData[`${lan.descrip_name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        required={false}
                                        type="textarea"
                                        placeholder={lan.name === "en" ? 'English' : lan.name === "ar" ? "العربية" : lan.name === "zh" ? "中文" : "Русский"}
                                    />
                                </Col>
                            )
                        })}
                    </CardBody>
                </Card >
                <Card className="w-100 mt-4">
                    <CardBody>
                        <Row>
                            {mapRender ? <MyMap
                                updateLocationPositions={updateLocationPositions}
                                lat={formData.lat}
                                lng={formData.lng}
                            /> : null}
                        </Row>
                        <Row className="mt-4">
                            <Col md={6}>
                                <SelectOptions
                                    label='Location'
                                    placeholder='Select'
                                    options={AreaOptions}
                                    handleSelectChange={(data) => {
                                        setFormData({ ...formData, selectedArea: data });
                                    }}
                                    selectedOption={formData.selectedArea}
                                    Service={AreasService}
                                    setOptions={(options) => {
                                        setAreaOptions(options)
                                    }}
                                />
                            </Col>
                            {Language.LIST.map((lan, index) => {
                                return (
                                    <Col md={12} key={index} >
                                        <AvField
                                            className="mb-3"
                                            name={lan.address_name}
                                            label={`Compound Address (${lan.name})`}
                                            bsSize="lg"
                                            value={formData[`${lan.address_name}`]}
                                            onChange={(e => handleFieldChange(e))}
                                            required={lan.name === "en" ? true : false}
                                            errorMessage="This field is required"
                                            placeholder={lan.name === "en" ? 'English' : lan.name === "ar" ? "العربية" : lan.name === "zh" ? "中文" : "Русский"}
                                        />
                                    </Col>
                                )
                            })}
                        </Row>
                    </CardBody>
                </Card >
                <Card className="w-100 mt-4">
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <FileUpload
                                    accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                    label='Compound Images'
                                    attachmentType='media_id'
                                    attachmentData={mediaIds}
                                    updatedAttachment={updatedAttachment}
                                    deleteAttachment={deleteAttachment}
                                    setUpload={()=> {}}
                                    multiple
                                    setUploadState={setUploadState}

                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card >
                <Card className="w-100 mt-4">
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <FileUpload
                                    accept='.mp4'
                                    label='Compound Videos'
                                    attachmentType='videos_id'
                                    attachmentData={videosIds}
                                    updatedAttachment={updatedAttachment}
                                    deleteAttachment={deleteAttachment}
                                    setUpload={()=> {}}
                                    multiple
                                    setUploadState={setUploadState}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card >
                {props.fromParams ? <Row className="mb-4">
                    <Col md={6}>
                        <button type="button" className="btn btnUpload btnHeight px-4" onClick={() => { setModal(true) }} >Cancel</button>
                    </Col>
                    <Col md={6} className=" d-flex flex-row-reverse">
                        <button type="submit" onClick={() => {
                            setGoOut(true)
                        }} className="btn btn-success btnHeight px-4"
                            disabled={uploadState ? true : loading ? true : false}
                        >Submit</button>
                    </Col>
                </Row> : <Row className="my-2">
                        <Card>
                            <CardBody>
                                <Row className="d-flex justify-content-between">
                                    <Col md={2}>
                                        <button type="button" onClick={() => setModal(true)} className="btn btn-light btnHeight  w-100  ">Cancel</button>
                                    </Col>
                                    <Col md={2} className="d-flex flex-row-reverse">
                                        <button type="submit" className="btn btn-success btnHeight  w-100 "
                                            disabled={uploadState ? true : loading ? true : false}
                                        >Continue</button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card >
                    </Row>}
                <CancelModal modal={modal}
                    toggle={() => setModal(!modal)}
                    btnOne="Cancel"
                    btnTwo="Go Back"
                    btnOneClick={() => setModal(false)}
                    btnTwoOclick={() => props ?.history ?.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)}
                />
                <SuccessModal
                    title={"Edit Compound"}
                    modal={successModal}
                    message={"Edited Compound Successfully"}
                    onClick={() => props ?.history ?.push(`${salesDeveloperPrefix}/compound/compound-list/${filterData?.developer_id}`)} />
            </AvForm>
        </React.Fragment >
    )
}
export default CompoundForm